module.exports = __webpack_public_path__ + "e2992f51c8b6dc2d66b64a2c6dd2228b.png";